import { ListColumn } from './ListColumn';
import { OPERATORS, TYPES } from '../utility-list';

export class ListColumnFilter /* extends ListColumn */ {
  name: string;
  type: string;
  operator: string;
  placeholder: string;
  contextForDropdown?: any[];
  labelForCheckbox?: string;
  checkBoxValue?: string;
  grow?: number;

  constructor(
    type: string = TYPES.INPUT,
    operator: string = OPERATORS.CONTAINS,
    name: string,
    prop: string,
    grow: number,
    reverse?: boolean
  ) {
    this.type = type;
    if (type === TYPES.CHECKBOX) {
      this.labelForCheckbox = name;
      this.checkBoxValue = reverse ? '0' : '1';
    }
    this.name = prop;
    this.operator = operator;
    this.placeholder = name;
    this.grow = grow;
  }
}

export const getFiltersConfig = (listColums: ListColumn<any>[]) => {
  let _filtersConfig: any[] = [];
  listColums.forEach((col) => {
    if (col.filter) {
      _filtersConfig.push(col.filter);
    }
  });

  return _filtersConfig;
};
